/**
 * @description Создать тело сообщения по ошибке.
 * @param {Error} error {Ошибка}
 * @returns {string}
 */
const makeBodyForError = (error) => {
  const stack = (error.stack || '')
    .split('\n')
    .map((line, index, items) => `#${items.length - index} ${line || 'empty'}`)
    .join(' ');
  return `${error.toString()} [stacktrace] ${stack}`;
};

/**
 * @description Сообщение журнала.
 * @param {Date}   createdAt Дата создания.
 * @param {string} body      Тело записи.
 * @param {string} level     Уровень.
 * @constructor
 */
function Message(createdAt, body, level) {
  const content = JSON.stringify({
    body,
    href: global.location?.href || '',
    level,
    timestamp: createdAt.getTime() / 1000,
    useragent: global.navigator?.userAgent || '',
  });
  /**
   * @description Получить строковое представление.
   * @returns {string}
   */
  this.toString = () => content;
}

/**
 * @description Транспорт журнала.
 * @param {import('axios').AxiosInstance} client Экземпляр клиента.
 * @param {string}                        uri    Идентификатор ресурса сообщения.
 * @constructor
 */
export function AxiosTransport(client, uri) {
  /**
   * @description Выполнить отправку сообщения.
   * @param {string} message Сообщение.
   * @returns {void}
   */
  this.send = (message) => { client.post(uri, message); };
}

/**
 * @description Журнал.
 * @param {AxiosTransport} transport Транспорт.
 * @constructor
 */
export default function Logger(transport) {
  const createMessageBy = (level, payload) => {
    if (payload instanceof Error) {
      return new Message(new Date(), makeBodyForError(payload), 'error');
    }
    return new Message(new Date(), String(payload), level);
  };
  /**
   * @description Отправить запись.
   * @param {string} level   Уровень.
   * @param {any}    payload Содержимое записи.
   * @returns {void}
   */
  this.log = (level, payload) => {
    const message = createMessageBy(level, payload);
    transport.send(message.toString());
  };
}
